import { createConsultation } from "../../../../api/clinic/consultationApi.js";
import { getPrimaryConsultServiceId } from "../components/ServiceRouting.js";

export const createConsultationIfNeeded = async (consultationData, lineItems, updateConsultationData) => {
  let consultationId = consultationData?.consultationId;
  
  if (!consultationId) {
    const primaryConsultServiceId = getPrimaryConsultServiceId(lineItems);
    const payload = {
      patientid: consultationData?.patientId,
      serviceid: primaryConsultServiceId || consultationData?.serviceId || consultationData?.baseServiceId,
      appointmentid: consultationData?.appointmentId,
      consultationmode: "TEN_STEP",
    };
    
    const resp = await createConsultation(payload);
    const newId = resp?.data?.consultationid || resp?.consultationid;
    
    if (!newId) {
      throw new Error("Unable to create consultation.");
    }
    
    consultationId = newId;
    updateConsultationData({ consultationId: newId });
  }
  
  return consultationId;
};
